module.exports = __webpack_public_path__ + "img/stock2.7a25f7f6.png";